import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "inline-block text-xs text-gray-500"
}
const _hoisted_2 = { key: 1 }

import { defineComponent } from 'vue';
import { UiCardDivider, UiCard, UiButton } from '@/ui-kit';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneDetailsPanel',
  props: {
    title: null,
    disabled: { type: Boolean },
    loading: { type: Boolean },
    subTitle: null,
    isActive: { type: Boolean },
    noCollapse: { type: Boolean }
  },
  emits: ["toggle"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_ElCollapseItem = _resolveComponent("ElCollapseItem")!
  const _component_ElCollapse = _resolveComponent("ElCollapse")!

  return (_openBlock(), _createBlock(_unref(UiCard), {
    class: _normalizeClass([
			'flex-grow text-dark-blue-400',
			__props.disabled ? 'cursor-not-allowed' : ''
		])
  }, {
    default: _withCtx(() => [
      (!__props.noCollapse)
        ? (_openBlock(), _createBlock(_component_ElCollapse, {
            key: 0,
            tabindex: "-1",
            modelValue: __props.isActive ? 'item' : null
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ElCollapseItem, {
                disabled: true,
                name: "item"
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass([
							'flex justify-between items-center',
							__props.disabled
								? 'cursor-not-allowed'
								: ''
						])
                  }, [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(__props.title) + " ", 1),
                      (__props.subTitle)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.subTitle), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_unref(UiButton), {
                      tabindex: "0",
                      class: "!h-8 !min-w-20",
                      theme: 
								__props.isActive
									? 'danger-outlined'
									: 'primary-outlined'
							,
                      loading: __props.loading,
                      disabled: __props.disabled,
                      loadingNoText: "",
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.isActive
									? 'Disable'
									: 'Enable'), 1)
                      ]),
                      _: 1
                    }, 8, ["theme", "loading", "disabled"])
                  ], 2)
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(UiCardDivider)),
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
              })
            ]),
            _: 3
          }, 8, ["modelValue"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (__props.title)
              ? (_openBlock(), _createBlock(_unref(UiCardDivider), {
                  key: 0,
                  title: __props.title,
                  subtitle: __props.subTitle
                }, null, 8, ["title", "subtitle"]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default")
          ]))
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})